<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-05-26 17:52:13
 * @Description: 进度条组件
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="player_progress">
    <div class="position-relative">
      <div class="player_progress_static">
        <span class="fz-22">{{ loadType || '加载中...' }}</span>
        <span class="fz-20">{{ percentage.toFixed(2) }}%</span>
      </div>
      <el-progress :text-inside="false" :stroke-width="26" :percentage="percentage"></el-progress>
    </div>
  </div>
</template>
<script>
export default {
  props: ['percentage', 'loadType'],
}
</script>
<style lang="scss" scoped>

.player_progress {
  position: absolute;
  top: 50%;
  left: 50%;
  color: #019cff;
  width: 412px;
  height: 200px;
  transform: translate(-206px, -100px);
  &_static {
    font-size: 30px;
  }
}
/deep/.el-progress {
  padding: 2px;
  border: 2px solid #027dfa;
  border-radius: 100px;
  &__text {
    display: none;
  }
  &-bar {
    margin-right: 0px;
    padding-right: 0px;
    &__inner {
      background: linear-gradient(45deg, #228bec, #2dfdff);
      box-shadow: 0 0 10px 6px #0078ff;
    }
    &__outer {
      height: 20px !important;
      background-color: rgba(0, 22, 82, 0.6);
      overflow: visible;
    }
  }
}

</style>
